class ModalController {
  constructor ($uibModalInstance) {
      this.$uibModalInstance = $uibModalInstance;
  }

  ok () {
      this.$uibModalInstance.dismiss('cancel');
  }
}

ModalController.$inject = ['$uibModalInstance'];

export {ModalController};



/** WEBPACK FOOTER **
 ** ./src/app/shared/services/modal/modal.controller.js
 **/